module.exports = __webpack_public_path__ + "af113eb3a67675d95557a5b4d91e2dff.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-flag-kit/assets/SB.svg
// module id = +73u
// module chunks = 0